import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  selector: 'app-page'
})
export class AppPageDirective extends UpgradeComponent  {
  constructor(elementRef: ElementRef, injector: Injector) {
      super('ng1AppPage', elementRef, injector);
  }
}
